import { render, staticRenderFns } from "./participants-modal.vue?vue&type=template&id=4ed45c32&"
import script from "./participants-modal.vue?vue&type=script&lang=js&"
export * from "./participants-modal.vue?vue&type=script&lang=js&"
import style0 from "./participants-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "participants-modal.vue"
export default component.exports